import { gql } from '@lcs/shared/api';

export const getMailboxDetail = gql`
   query GetMailboxDetail($id: UInt!) {
      mailbox(id: $id) {
         emailAddress
         discardAudioAfterEmail
         markReadAfterEmail
         isInNameDirectory
         sayCallerId
         mailboxId
         password
         unavailablePromptId2
         unavailablePrompt {
            promptId
            name
            typeId
            isActive
            accountId
            file {
               fileId
               fileName
               displayName
               fileToken
            }
            isReusable
         }
         temporaryUnavailablePromptId
         temporaryUnavailablePrompt {
            promptId
            name
            typeId
            isActive
            accountId
            file {
               fileId
               fileName
               displayName
               fileToken
            }
            isReusable
         }
         mailboxOperatorExtension {
            extensionId
            name
            number
         }
         operatorExtensionId
         namePromptId
         namePrompt {
            promptId
            name
            typeId
            isActive
            accountId
            file {
               fileId
               fileName
               displayName
               fileToken
            }
            isReusable
         }
         busyPromptId
         busyPrompt {
            promptId
            name
            typeId
            isActive
            accountId
            file {
               fileId
               fileName
               displayName
               fileToken
            }
            isReusable
         }
         mailboxMessagesConnection {
            items {
               mailboxMessageId
               timestamp
               sender
               isRead
               mailboxFolderId
               isArchived
               file {
                  fileToken
               }
            }
         }
         extension {
            extensionId
            extensionType {
               name
            }
            account {
               accountId
               name
               operatorExtension {
                  name
                  number
               }
            }
            name
            number
         }
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
   }
`;
